import { get } from 'lodash'

export default function(awardLevelValue, selectedParticipants) {
  // const participants = selectedParticipants.map(participant => (
  //   participant.awards
  //     .filter(awardItem => awardItem.awardLevel.value === awardLevelValue)
  //     .map(awardItem => ({
  //       id: awardItem.id,
  //       participant: {
  //         id: participant.id
  //       }
  //     }))[0]
  // ))

  const participants = selectedParticipants
    .filter(item => get(item, 'award.awardLevel.value') === awardLevelValue)
    .map(item => ({
      id: item.award.id
    }))

  return {
    awards: [...participants]
  }
}
